import { APIRoute } from '@/modules/utils'
import { ShadowOptin } from '@/data'
import { HydraCollection } from 'emt-library'

export const Route: APIRoute = {
  method: 'GET',
  path: '/v2/shadow_optins',
}

export type Response = HydraCollection<ShadowOptin>
